import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Scrolls to the element matching the current URL hash (e.g. `#cardiovascular`)
 * whenever the hash changes. Used so the history-progress subsection links can
 * jump to their section on the page (across pages or within the same page).
 */
export const useScrollToHash = () => {
    const { hash } = useLocation();

    useEffect(() => {
        if (!hash) return;

        const el = document.getElementById(hash.slice(1));

        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [hash]);
};
